import { ActionIcon, Switch } from "@mantine/core";
import { IconTrash } from "@tabler/icons-react";
import type { AdditionalQuestionsConfig, Question } from "../../../types";
import { ChoiceButton } from "../../Tax Pro Only/ChoiceButton/ChoiceButton";

interface QuestionSettingsProps {
  id: string;
  handleQuestionChange: (
    id: string | undefined,
    field: keyof Question,
    value: any
  ) => void;
  localChanges: AdditionalQuestionsConfig;
  setLocalChanges: React.Dispatch<
    React.SetStateAction<AdditionalQuestionsConfig>
  >;
  setHasUnsavedChanges: (hasChanges: boolean) => void;
  handleDeleteQuestion: (id: string) => void;
}

const QuestionSettings = ({
  id,
  handleQuestionChange,
  localChanges,
  handleDeleteQuestion,
}: QuestionSettingsProps) => {
  const question = localChanges.questions.find(
    (question) => question.id === id
  );

  return (
    <div className="right-section">
      <h3>Settings</h3>
      <div className="options">
        <div className="question-type">
          <h3>Question type</h3>
        </div>
        <ChoiceButton
          label="Short Answer"
          className={`question-choice ${
            question?.type.name === "shortInput" ? "checked" : ""
          }`}
          data-intercom-target="question-type-short-answer"
          checked={question?.type.name === "shortInput"}
          onClick={() =>
            handleQuestionChange(question?.id, "type", {
              name: "shortInput",
            })
          }
        />
        <ChoiceButton
          label="Long Answer"
          className={`question-choice ${
            question?.type.name === "longInput" ? "checked" : ""
          }`}
          data-intercom-target="question-type-long-answer"
          checked={question?.type.name === "longInput"}
          onClick={() =>
            handleQuestionChange(question?.id, "type", {
              name: "longInput",
            })
          }
        />
        <ChoiceButton
          label="Document Upload"
          className={`question-choice ${
            question?.type.name === "docUpload" ? "checked" : ""
          }`}
          data-intercom-target="question-type-document-upload"
          checked={question?.type.name === "docUpload"}
          onClick={() =>
            handleQuestionChange(question?.id, "type", {
              name: "docUpload",
            })
          }
        />
      </div>
      <Switch
        label="Required"
        className="question-required"
        data-intercom-target="question-required"
        size="md"
        checked={question?.isRequired}
        onChange={(event) =>
          handleQuestionChange(
            question?.id,
            "isRequired",
            event.currentTarget.checked
          )
        }
      />
      <ActionIcon
        className="question-delete-btn"
        size={22}
        data-intercom-target="question-delete"
        color="#DC373A"
        variant="transparent"
        onClick={() => handleDeleteQuestion(id)}
      >
        <IconTrash />
      </ActionIcon>
    </div>
  );
};

export default QuestionSettings;
